import React from 'react';

import queryString from 'query-string';
import { connect } from 'react-redux';
//import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';

import {
  fetchBannerMsg,
  hideStatusMsg,
  onSuccessMsg,
} from '../../actions/FlashMessage/FlashMessages';
import { getOrgsSearch, getStatusesSearch, } from '../../actions/Users/UserAction';
import { impersonateUserEnd, setUserImpersonateRequestComplete } from '../../actions/Users/ImpersonateAction';
import Api from '../../Api';
import BannerMessages from '../Common/Messages/BannerMessages';
import FlashMessages from '../Common/Messages/FlashMessages';
import Feedback from '../Feedback/Feedback';
import Footer from '../Footer/Footer';
import HeaderAuth from '../Headers/HeaderAuth';
import ScreenReaderMsg from '../Headers/ScreenReaderMsg';
import { JumpToContent, JumpToContentAnchor } from '../Headers/SkipToContent';
import SideNav from '../SideNav/SideNav';
import { Fragment } from 'react';
import { Loading } from '../Common';
import { ADMINISTRATOR_USER, ASSOCIATION_USER } from '../../actionTypes/Users/UserActionType';
import { compareIgnoreCase } from '../../utils/helpers';
import withNavigate from '../HOC/navigate';
import withLocation from '../HOC/WithLocation';

const api = new Api();

class Layout extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      loggedAs: '',
      queryParams: {},
      isBusy: false,
    };
    this.endImpersonationRef = React.createRef();

    this.checkAssocAndAdminUserAccess = this.checkAssocAndAdminUserAccess.bind(this)
  }

  async onAfterImpersonateModeEnded () {
    this.props.navigate(`/userDetails?guid=${this.props.lastUserDetailsGUID}`);
    }

  componentDidUpdate(prevProps) {
    const isImpersonateEnded = prevProps.userPersonated && !this.props.userPersonated;
    const isImpersonateStarted = !prevProps.userPersonated && this.props.userPersonated;

    isImpersonateEnded ? this.onAfterImpersonateModeEnded() : void 0;
    isImpersonateStarted ? (this.endImpersonationRef.current && this.endImpersonationRef.current.focus()) : void 0;

    this.hideMsgOnChangePath(prevProps);
    this.showBannerMsgForSuperUser(prevProps);
  }

  componentDidMount() {
    this.props.hideStatusMsg();
    this.props.setUserImpersonateRequestComplete();

    if (this.props.linkName === 'reports') {
      const queryParams = queryString.parse(this.props.location.search);
      this.setState({
        queryParams: queryParams,
      });
    }

    this.showBannerMsgForSuperUser();
  }

  hideMsgOnChangePath(prevProps) {
    if (
      this.props.location.pathname !== prevProps.location.pathname &&
      this.props.statusMessage.msgShow
    ) {
      this.props.hideStatusMsg();
    }
    if (this.props.location.state && this.props.location.state.statusMessage && !this.props.statusMessage.msgShow) {
      this.props.onSuccessMsg(this.props.location.state.statusMessage);
      // reset location state object
      this.props.navigate(location.pathname.replace('/analytics/ui', '') + location.search, {});
    }
  }

  showBannerMsgForSuperUser(prevProps) {
    const { location } = this.props;
    (!prevProps || (location.pathname !== prevProps.location.pathname && location.pathname === '/users')) ?
      this.props.fetchBannerMsg() : void 0;
  }

  endImpersonate(event) {
    event.preventDefault();
    this.props.impersonateUserEnd();
  }

  renderImpersonateStatusBar() {
    const { userPersonated: { given_name, family_name, email, impersonating } } = this.props;
    return (
      <div className={'impersonation v-middle-align headerContainer'}>
        <div className="w-100 text-right">
          <span id="endImpersonate">
            Impersonating {given_name} {family_name} ({email})
          </span>
          <button
            ref={this.endImpersonationRef}
            tabIndex={impersonating ? '0' : '-1'}
            aria-describedby="endImpersonate"
            className="end-impersonation"
            data-testid='endImpersonate'
            onClick={(e) => this.endImpersonate(e)}>
            <i className="fas fa-eye-slash mRight-5"></i>End Impersonation
          </button>
        </div>
      </div>
    );
  }
  checkAssocAndAdminUserAccess() {
    const { userDetails } = this.props;
    if ([ADMINISTRATOR_USER, ASSOCIATION_USER].includes(userDetails.userRoleConstant) && compareIgnoreCase(userDetails.userManagementAccess, "True")) {
      return true;
    } else
      return false;
  }

  render() {
    const { linkName: LinkName, userPersonated } = this.props;
    const headerClassName = this.props.headerZIndex ? 'headerContainer increaseHeader-z-index ' : 'headerContainer ';
    return (
      <Fragment>

        <JumpToContent />
        <HeaderAuth props={this.props} classNames={[headerClassName, userPersonated ? 'top-30 mode-impersonation' : '']}>
          {userPersonated ? this.renderImpersonateStatusBar() : void 0}
          <ScreenReaderMsg />
        </HeaderAuth>

        <SideNav linkName={LinkName} />

        <main
          role="main"
          aria-describedby="app_page_title"
          className={'main-page ' + (userPersonated ? 'top-113' : '')}>
          <JumpToContentAnchor />
          <div
            tabIndex="0"
            className={
              'render-body-container init-focus ' +
              ((this.props.sideNavToggle || this.props.reportMenu.length === 0) || this.checkAssocAndAdminUserAccess() ? '' : 'render-active')
            }>
            <BannerMessages msg={this.props.bannerMessage.msg} msgShow={this.props.bannerMessage.msgShow} />
            <FlashMessages
              scope="Layout"
              showMsg={this.props.statusMessage.msgShow}
              close={this.props.hideStatusMsg}
              type={this.props.statusMessage.msgType}
              open={this.props.statusMessage.msgShow}
              msg={this.props.statusMessage.msg}
              boldMsg={this.props.statusMessage.boldMsg}
              classNames={'fl-layout'}
            />
            <Loading show={this.props.impersonateBusy || this.state.isBusy} backdrop classNames={['app-impersonate-loading']} />
            {this.props.children}
          </div>
        </main>

        <Footer
          className={
            'footerContainer render-body-container ' +
            ((this.props.sideNavToggle || this.props.reportMenu.length === 0) || this.checkAssocAndAdminUserAccess() ? '' : 'render-active')
          }>
          <Feedback />
        </Footer>

      </Fragment>
    );
  }
}
function mapStateToProps(state) {
  return {
    statusMessage: state.FlashMessages.statusMsg,
    bannerMessage: state.FlashMessages.bannerMsg,
    sideNavToggle: state.Page.sideNavToggle,
    reportMenu: state.Page.reportMenus.reportMenus,
    userPersonated: state.Impersonate.impersonate.userPersonated,
    impersonateBusy: state.Impersonate.loading,
    headerZIndex: state.Page.headerZIndexToggle,
    lastUserDetailsGUID: state.Users.previewUser?.guid,
    userDetails: state.AppSession.userDetails,
  };
}
function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getOrgsSearch,
      getStatusesSearch,
      impersonateUserEnd,
      setUserImpersonateRequestComplete,
      onSuccessMsg,
      hideStatusMsg,
      fetchBannerMsg,
    },
    dispatch,
  );
}

//export default connect(mapStateToProps, matchDispatchToProps)(withRouter(Layout));
export default connect(mapStateToProps, matchDispatchToProps)(withLocation(withNavigate(Layout)));
